import {
  Unit21DataClassifier,
  OrgDataSettingsConfig,
} from 'app/modules/dataSettings/responses';
import {
  U21RadioGroupOptionProps,
  U21SelectOptionProps,
} from 'app/shared/u21-ui/components';
import {
  FullTxnResponse,
  ShortTxnResponse,
} from 'app/modules/transactions/types';
import {
  FullInstrumentResponse,
  ShortInstrumentResponse,
} from 'app/modules/instruments/responses';

// all core integrations
export enum BankingIntegrationType {
  CORELATION_KEYBRIDGE = 'corelation_keybridge',
  FINXACT = 'finxact',
}

// banking cores that have banking actions
export enum ActionMappingIntegrationType {
  CORELATION_KEYBRIDGE = 'corelation_keybridge',
}

export enum ObjectActionType {
  BLOCK_CARD = 'block_card',
  ACTIVATE_CARD = 'activate_card',
  CHECK_HOLD = 'check_hold',
  STOP_PAYMENT = 'stop_payment',
}

export enum PortXOrcaActionType {
  UPDATE_ACCOUNT = 'update_account',
  DEACTIVATE_CARD = 'deactivate_card',
}

export type BankingActionType = ObjectActionType | PortXOrcaActionType;

export enum ObjectType {
  INSTRUMENT = 'INSTRUMENT',
  TRANSACTION = 'TXN_EVENT',
}

export interface ActionMapping {
  id: number;
  integration_type: ActionMappingIntegrationType;
  object_type: ObjectType;
  action_type: ObjectActionType;
  name: string;
  description?: string;
  field_mappings?: Record<string, number | string>;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface ConditionalFieldConfig {
  readonly field: string;
  readonly conditionalFields: ReadonlyArray<string>;
  readonly optional: boolean;
}

export interface ConditionalRequiredConfig {
  readonly [fieldValue: string]:
    | ReadonlyArray<string>
    | { readonly one_of: ReadonlyArray<string> };
}

export interface ActionMappingFormConfig {
  actionTypeOptions: ReadonlyArray<U21SelectOptionProps<ObjectActionType>>;
  objectTypeOptions: ReadonlyArray<U21RadioGroupOptionProps<ObjectType>>;
  actionSchemas: Readonly<
    Record<
      ObjectActionType,
      Readonly<{
        readonly required: ReadonlyArray<string>;
        readonly optional: ReadonlyArray<string>;
        readonly eitherOrFields?: ReadonlyArray<string>;
        readonly conditionalByField?: ReadonlyArray<ConditionalFieldConfig>;
        readonly conditionalRequired?: Readonly<
          Record<string, ConditionalRequiredConfig>
        >;
      }>
    >
  >;
  dataSettingFields?: ReadonlyArray<string>;
}

export interface ActionMappingFormValues {
  integrationType: ActionMappingIntegrationType;
  actionType: ObjectActionType;
  objectType: ObjectType;
  mappingName: string;
  description?: string;
  fieldMappingArray: { key: string; value?: number | string }[];
}

export interface IntegrationFormProps {
  objectType?: ObjectType;
  dataSettingsByClassifier: Record<
    Unit21DataClassifier,
    OrgDataSettingsConfig[]
  >;
  onFormChange?: () => void;
}

export interface TransactionData {
  objectType: ObjectType.TRANSACTION;
  actionData: FullTxnResponse | ShortTxnResponse;
}

export interface InstrumentData {
  objectType: ObjectType.INSTRUMENT;
  actionData: FullInstrumentResponse | ShortInstrumentResponse;
}

export enum CoreApiFinxactTestStatus {
  SUCCESS = 'SUCCESS',
  NO_CONFIG = 'NO_CONFIG',
  BAD_AUTH = 'BAD_AUTH',
  CREDENTIALS_DECRYPTION_ERROR = 'CREDENTIALS_DECRYPTION_ERROR',
  BAD_CREDENTIALS_TYPE = 'WRONG_CREDENTIALS',
  BAD_BASE_URL = 'BAD_BASE_URL',
  WEB_EXCEPTION = 'WEB_EXCEPTION',
  UNEXPECTED_STATUS = 'UNEXPECTED_STATUS',
}
